const DEFAULT_DEPLOYED_BASE_PATH = '/digital/servicing/SDE_DV';

const trimTrailingSlash = (value) => value.replace(/\/+$/, '');

export const normalizeBasePath = (basePath, { trailingSlash = false } = {}) => {
    const candidate = (basePath || '/').trim();
    if (!candidate || candidate === '/') {
        return '/';
    }

    const normalized = candidate.startsWith('/') ? candidate : `/${candidate}`;
    const withoutTrailingSlash = trimTrailingSlash(normalized);
    return trailingSlash ? `${withoutTrailingSlash}/` : withoutTrailingSlash;
};

export const getConfiguredBasePath = () => {
    if (typeof window !== 'undefined' && typeof window.__SDE_BASE_PATH__ === 'string') {
        return normalizeBasePath(window.__SDE_BASE_PATH__);
    }

    if (typeof process !== 'undefined' && process.env && typeof process.env.BASE_NAME === 'string') {
        return normalizeBasePath(process.env.BASE_NAME);
    }

    return DEFAULT_DEPLOYED_BASE_PATH;
};

export const getBasePathFromLocation = (configuredBasePath = getConfiguredBasePath()) => {
    if (typeof window === 'undefined' || !window.location) {
        return normalizeBasePath(configuredBasePath);
    }

    const pathName = (window.location.pathname || '/').toLowerCase();
    const normalizedConfiguredBasePath = normalizeBasePath(configuredBasePath).toLowerCase();
    if (normalizedConfiguredBasePath !== '/' && pathName.startsWith(normalizedConfiguredBasePath)) {
        return normalizeBasePath(configuredBasePath);
    }

    return '/';
};

export { DEFAULT_DEPLOYED_BASE_PATH };